import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { HiMenuAlt1 } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap'
import { Nav, Navbar, Dropdown, Container, Image } from 'react-bootstrap'
// import { admin_logout } from '../../redux/actions/adminAuthActions'
// import { user_logout } from '../../redux/actions/userAuthActions'
// import '../assets/styles/navbar.css'
import logo from '../../assets/logo.png'

const Header = ({ loc }) => {
	const dispatch = useDispatch()
	const [detail, setDetail] = useState(false)

	// const userAuth = useSelector((state) => state.userAuth)
	// const { userDetail } = userAuth

	// const adminAuth = useSelector((state) => state.adminAuth)
	// const { detail } = adminAuth

	// const getCurrentCampaign = useSelector((state) => state.getCurrentCampaign)
	// const { currentCampaign } = getCurrentCampaign

	const adminLogoutHandler = (e) => {
		e.preventDefault()
		// dispatch(admin_logout())
	}

	// useEffect(() => {
	// 	dispatch(get_current_campaign_user())
	// }, [dispatch])

	return (
		<header>
			<Navbar
				className='home_nav home_nav1 fixed-top'
				expand='lg'
				collapseOnSelect
			>
				<Container>
					<LinkContainer to='/'>
						<Link to='/home'>
							<img src={logo} alt='logo' style={{ width: '6rem' }} />
						</Link>
					</LinkContainer>
					<Navbar.Toggle aria-controls='basic-navbar-nav'>
						<HiMenuAlt1 />
					</Navbar.Toggle>
					<Navbar.Collapse id='basic-navbar-nav'>
						<Nav className='ml-auto'>
							<LinkContainer to='/home'>
								<Nav.Link className='js-scroll'> Home </Nav.Link>
							</LinkContainer>
							<LinkContainer to='/about-us'>
								<Nav.Link className='js-scroll'> About Us </Nav.Link>
							</LinkContainer>
							<LinkContainer to='/properties'>
								<Nav.Link className='js-scroll'> Properties </Nav.Link>
							</LinkContainer>
							<LinkContainer to='/contact-us'>
								<Nav.Link className='js-scroll'> Contact Us </Nav.Link>
							</LinkContainer>
							{detail ? (
								<LinkContainer to='#'>
									<Dropdown className='js-scroll'>
										<Dropdown.Toggle
											variant=''
											className='js-scroll2 pt-2 camp_btn'
											id='dropdown-basic'
										>
											{detail && <span>Hello, {detail.name} </span>}
										</Dropdown.Toggle>

										<Dropdown.Menu>
											<LinkContainer to='/admin/dashboard/home'>
												<Nav.Link className=''> My Dashboard </Nav.Link>
											</LinkContainer>
											<LinkContainer to='#' onClick={adminLogoutHandler}>
												<Nav.Link className=''> Sign Out </Nav.Link>
											</LinkContainer>
										</Dropdown.Menu>
									</Dropdown>
								</LinkContainer>
							) : null}
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</header>
	)
}

export default Header
